'use client';

import { Toast, ToastProvider, ToastViewport } from '../Toast';
import { useToast } from 'shared/hooks/useToast';

const Toaster = () => {
  const { toasts } = useToast();

  return (
    <ToastProvider swipeDirection="right">
      {toasts.map(({ id, ...props }) => {
        return <Toast key={id} {...props} />;
      })}
      <ToastViewport />
    </ToastProvider>
  );
};

export { Toaster };
